export default __webpack_public_path__ + "static/media/11.ac81b50d.PNG";